export default __webpack_public_path__ + "static/media/ChickenParm.f4ebbf12.jpg";